import { render, staticRenderFns } from "./ProfileMembers.vue?vue&type=template&id=0770e016"
import script from "./ProfileMembers.vue?vue&type=script&lang=js"
export * from "./ProfileMembers.vue?vue&type=script&lang=js"
import style0 from "./ProfileMembers.vue?vue&type=style&index=0&id=0770e016&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports